import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import axios from "axios";
import "./App.css";

/* ========== RuPay-eligible CREDIT cards (kept as-is) ========== */
const RupayCards = [
  "MakeMyTrip ICICI Bank Signature Credit Card",
  "Axis Bank Supermoney Rupay Credit Card",
  "Shoppers Stop HDFC Bank Credit Card",
  "Axis Bank Neo Credit Card",
  "Indian Coast Guard Rakshamah Bank of Baroda",
  "Tata Neu Plus HDFC Bank Credit Card",
  "Tata Neu Plus SBI Card",
  "Fed Starbiz Rupay Credit Card",
  "SBM Gild Credit Card",
  "UCO Bank SimplySAVE SBI Card",
  "Poonawalla Fincorp IndusInd Bank eLITE RuPay Credit Card",
  "Yes Bank Anq Pi Credit Card",
  "Federal Bank Rupay Signet Credit Card",
  "Union Bank Rupay Platinum Credit Card",
  "Karnataka Bank Simplysave SBI Card",
  "RBL Bank VCard",
  "Federal Bank Scapia Credit Card",
  "SBM Kredit.Pe Credit Card",
  "Kotak Mojo Platinum Credit Card",
  "HDFC Bank UPI Rupay Biz Credit Card",
  "HPCL Energie Bobcard",
  "Apollo SBI Card Select",
  "PNB Rakshak Rupay Platinum Card",
  "Indianoil Kotak Credit Card",
  "Ixigo AU Travel Credit Card",
  "PNB RuPay Platinum Credit Card",
  "Federal Bank Wave Credit Card",
  "Bank of India Rupay Platinum Credit Card",
  "Bank of India SwaDhan Rupay Platinum Credit Card",
  "Kotak League Platinum Credit Card",
  "PNB EMT Rupay Platinum Credit Card",
  "HDFC Bank Biz Grow Credit Card",
  "SimplySave SBI Card",
  "Canara Bank Rupay Platinum Secured Credit Card",
  "Indusind Samman RuPay Credit Card",
  "Paytm SBI Credit Card",
  "BPCL SBI Credit Card",
  "YES Bank Paisabazaar Paisasave Credit Card",
  "Yatra SBI Card",
  "IndusInd Bank Platinum RuPay Credit Card",
  "Axis KWIK Credit Card",
  "Reliance SBI Card",
  "Canara Bank Rupay Platinum Credit Card",
  "PSB SimplySAVE SBI Card",
  "UNI Carbon Credit Card.",
  "PNB Rupay Millennial Card",
  "Yes Bank Card Anq Phi Credit Card",
  "HDFC Bank Biz Power Credit Card",
  "UCO Bank SBI Card Elite",
  "Indian Navy Varunah Premium Bobcard",
  "IndianOil Axis Bank Credit Card",
  "CMA One Bobcard",
  "Shaurya SBI Card",
  "South Indian Bank Simplysave SBI Card",
  "IRCTC SBI Card Rupay",
  "PNB Patanjali Rupay Platinum Card",
  "Fibe Axis Bank Rupay Credit Card",
  "Paytm AU Credit Card",
  "AU Kosmo Credit Card",
  "AU Spont Credit Card",
  "AU Xcite Ace Credit Card",
  "Cheq AU Credit Card",
  "AU Bank Pratham Credit Card",
  "AU Business Cashback Credit Card",
  "Kosmo Credit Card",
  "Google Pay Flex SBI Credit Card",
  "AU Xcite Credit Card",
  "AU Zaggle Rupay Credit Card"
];

/* ========== RuPay-eligible DEBIT cards (your array) ========== */
const RupayDebitCards = [
  "Rupay Crown Debit Card",
  "Rupay Platinum Contactless Debit Card",
  "RuPay PMJDY Debit Card",
  "Bandhan Bank RuPay Platinum Debit Card",
  "Bandhan Bank RuPay Classic Debit Card",
  "Bandhan Bank PMJDY (Pradhan Mantri Jan-Dhan Yojana) Debit Card",
  "Catholic Syrian Bank RuPay Platinum",
  "Catholic Syrian Bank RuPay Classic",
  "Catholic Syrian Bank RuPay PMJDY",
  "Catholic Syrian Bank Senior Citizen Debit Card",
  "Catholic Syrian Bank Women Debit Card",
  "Catholic Syrian Bank Salary Debit Card (HV)",
  "Catholic Syrian Bank Platinum Max Debit Card",
  "KBL MoneyPlant NCMC Contactless RuPay Platinum International Debit Card",
  "KBL MoneyPlant RuPay Classic Debit Card",
  "KBL MoneyPlant RuPay Platinum International Debit Card",
  "KBL MoneyPlant RuPay Kisan Debit Card",
  "KBL MoneyPlant RuPay MUDRA Card",
  "KBL MoneyPlant NCMC RuPay Select International Premium Debit Card",
  "KBL MoneyPlant RuPay PMJDY Debit Card",
  "KBL MoneyPlant RuPay International Platinum Debit Card",
  "KBL MoneyPlant NCMC RuPay Domestic Debit Card",
  "IDBI Bank RuPay Platinum Debit Card",
  "IDBI Bank RuPay Platinum NCMC Card",
  "IDBI Bank RuPay Classic NCMC Card",
  "IDBI Bank RuPay Classic Debit Card",
  "IDBI Bank RuPay Women's Debit Card",
  "IDBI Bank RuPay Kids Debit Card",
  "IDBI Bank RuPay Mudra Debit Card",
  "IDBI Bank RuPay Kisan Card",
  "IDBI Bank RuPay PMJDY Card",
  "RBL Bank FINJA Debit card",
  "RBL Rupay Debit Card",
  "RBL Rupay Kisan Debit Card",
  "Axis Bank Kisan Debit Card",
  "Axis Bank PMJDY Rupay Debit Card",
  "Axis Bank Republic Debit Card",
  "Axis Bank Rupay Platinum Debit Card",
  "Axis Bank Power Salute Debit Card",
  "Axis Bank Titanium Prime Plus Debit Card",
  "Axis Bank RuPay Platinum NRO Debit Card",
  "Kotak Rupay Debit Card",
  "Kotak Everyday Debit Card",
  "Kotak Classic One Debit Card",
  "AU Platinum Debit Card",
  "AU RuPay Platinum Debit Card",
  "AU RuPay Classic Debit Card",
  "Equitas Rupay Classic Debit Card",
  "Equitas Rupay Platinum Debit Card",
  "Equitas RuPay Insta Classic Saving Debit Card",
  "Equitas RuPay Insta Classic Current Debit Card",
  "Capital Classic Debit Card",
  "Capital Classic Business Debit Card",
  "Capital Platinum Debit Card",
  "Capital Platinum Business Debit Card",
  "Capital International Platinum Debit Card",
  "Capital Virtual Debit Card",
  "Utkarsh RuPay Classic Domestic Debit Cards",
  "Utkarsh RuPay Platinum Domestic Debit Cards",
  "Utkarsh RuPay Select International Contactless Debit Cards",
  "Utkarsh RuPay Classic International Contactless Debit Card",
  "Utkarsh RuPay Platinum International Contactless Debit Card",
  "Shivalik RuPay Classic Debit Card",
  "Shivalik RuPay Platinum Debit Card",
  "Airtel Transit Debit Card (NCMC-enabled)",
  "Airtel Virtual Debit Card (digital-only via Airtel Thanks app)",
  "Fino Platinum Debit Card",
  "Central Bank Rupay Select Wellness Card",
  "Central Bank Rupay Platinum Debit Card",
  "Central Bank Rupay Classic Debit Card",
  "Central Bank Business Card",
  "Bank of India RuPay Sangini Debit card",
  "Bank of India Rupay PMJDY Debit card",
  "Bank of India Rupay Mudra Debit card",
  "Bank of India Rupay Kisan Debit card",
  "Bank of India Rupay Punjab Arthia card",
  "Bank of India Rupay NCMC Debit Card",
  "Canara Bank Rupay Select Debit Card",
  "Canara Bank Rupay Platinum International Debit Card",
  "Canara Bank Rupay Platinum Domestic Debit Card",
  "Canara Bank Rupay Classic Debit Card",
  "Indian Bank RuPay Platinum Card (Contact)",
  "Indian Bank RuPay Platinum Card (Contactless)",
  "Indian Bank Rupay International Platinum Card (Contact)",
  "Indian Bank RuPay Debit Select Card (Contactless)",
  "Indian Bank Rupay Classic contactless card (NCMC)",
  "Indian Bank DIGI- RuPay Classic Card",
  "Indian Bank DIGI- Rupay Classic Card (Contactless)",
  "Indian Bank Senior Citizen Debit Card (Contact)",
  "Indian Bank PMJDY Card (Contact)",
  "Indian Bank PMJDY Card (Contactless)",
  "Indian Bank Kalaignar Magalir Urimai Thittam (KMUT) Scheme Cards  Contactless",
  "Indian Bank Rupay Kisan Card",
  "Indian Bank MUDRA Card (Micro Units Development and Refinance Agency)",
  "Union Bank HNI Emperio Metal Debit Card",
  "Union Bank Rupay Empower Her Debit Card",
  "Union Bank Qsparc Debit Card (Rupay)",
  "Union Bank of India Business Debit Card (Platinum)",
  "Union Bank of India Classic Debit Card Rupay",
  "Union Bank of India Platinum Debit Card",
  "Union Bank of India Rupay Select Debit Card",
  "Union Bank of India Rupay JCB Platinum Urnro and Urnre",
  "SBI Virtual Debit Card",
  "SBI Global International Debit Card",
  "SBI Platinum International Debit Card",
  "SBI IOCL Co-Branded Contactless RuPay Debit Card",
  "SBI Nari Shakti Platinum Debit Card",
  "SBI Pragati Platinum Debit Card",
  "Bank of Baroda Bhoomi RuPay Select Debit Card",
  "Bank of Baroda RuPay Select Debit Card",
  "Bank of Baroda Rupay Platinum Debit Card",
  "Baroda BPCL Debit Card",
  "Bank of Baroda World Yoddha Debit Card",
  "Bank of Baroda World Agniveer Debit Card",
  "Bank of Baroda Rupay Classic Debit Card",
  "Bank of Baroda RuPay Qsparc NCMC Debit Card",
  "Bank of Baroda Virtual Debit Card",
  "Bank of Baroda inSIGHT Braille Debit Card",
  "UCO Bank RuPay Platinum Insta Contactless Debit Card",
  "UCO RuPay Platinum Personalised Contactless Debit Card",
  "UCO Bank RuPay Select Personalised Debit Card",
  "UCO Bank RuPay Platinum International Debit Card",
  "UCO Bank RuPay Metal ETERNA Debit Card",
  "UCO Bank Aprajita Debit Card",
  "PNB Rupay NCMC Classic Debit Card",
  "PNB Rupay NCMC Platinum Domestic Debit Card",
  "PNB Rupay NCMC Platinum International Debit Card",
  "PNB Rupay Select Debit Card",
  "PNB Rupay Women Power Platinum Debit Card",
  "PNB Business Platinum NCMC Debit Card",
  "PNB Rupay Classic Virtual Debit Card",
  "PNB Rupay Select Neo Debit Card",
  "PNB Rupay Select Excel Debit Card",
  "PNB Rupay Select Optima Debit Card",
  "PNB Rupay Select Imperial Debit Card",
  "PNB Rupay Select Rakshak Debit Card",
  "PNB Rupay Select Rakshak Optima Debit Card",
  "PNB Rupay Select Rakshak Imperial Debit Card",
  "PNB Rupay Select Samriddhi Debit Card",
  "PNB Rupay Platinum Harit Debit Card",
  "PNB Rupay Platinum Pearl Debit Card",
  "PNB Rupay Platinum Emerald Debit Card",
  "PNB Rupay Platinum Solitaire Debit Card",
  "PNB Rupay Platinum Vishwas & Varishth Debit Card",
  "PNB Rupay Platinum Vaibhav Debit Card",
  "PNB Rupay Palaash Recycled PVC Debit Card",
  "PNB Rupay Antah Drishti Braille Debit Card",
  "PNB Pay ON-THE-GO Wearable Debit Card",
  "SIB Rupay Kisan Debit Card",
  "SIB Rupay Mudra Debit Card",
  "SIB Rupay PMJDY Debit Card",
  "SIB RuPay Classic NCMC Debit Card",
  "SIB RuPay Platinum EMV Debit Card",
  "SIB Rupay Platinum Explorer NCMC Debit Card",
  "IDFC RuPay Platinum Debit Card",
  "IDFC RuPay Classic Debit Card",
  "HDFC Classic Platinum Debit Card",
  "HDFC Vishesh Platinum Debit Card",
  "HDFC GIGA Business Debit Card",
  "HDFC MoneyBack Debit Card",
  "HDFC EasyShop Preferred Platinum Debit Card",
  "HDFC EasyShop Classic Platinum Debit Card",
  "HDFC EasyShop Platinum Debit card",
  "HDFC EasyShop Vishesh Debit Card",
  "HDFC Business Debit Card",
  "HDFC Rupay Platinum Debit Card",
  "HDFC Rupay NRO Debit Card",
  "HDFC Regular Debit Card",
  "HDFC Kids Advantage Debit Card",
  "HDFC RuPay PMJDY Debit Card",
  "IPPB Rupay Virtual Debit Card",
  "Yes Engage Debit Card",
  "Yes Element Debit Card",
  "Yes Elegance Debit Card",
  "Yes Explore Debit Card",
  "Yes Bank PMJDY Rupay Chip Debit Card",
  "Federal Rupay Crown Debit Card",
  "Federal Rupay Platinum Contactless Debit Card",
  "Federal RuPay PMJDY Debit Card",
  "Dhanlaxmi RuPay Platinum International Debit Card",
  "Dhanlaxmi RuPay Classic International Debit Card",
  "Dhanlaxmi RuPay Classic Debit Card",
  "Dhanlaxmi RuPay PMJDY Debit Card",
  "DCB RuPay Platinum Debit Card",
  "DCB RuPay Platinum Debit Card (Basic)",
  "KVB Prestige Debit Card",
  "J&K RuPay Classic (Personalised/ Instant)",
  "J&K RuPay PMJDY (Instant / Personalised)",
  "J&K RuPay Mudra",
  "J&K RuPay Kissan",
  "TMB Select International Debit Card",
  "TMB Classic Non-Photo Card",
  "TMB Kisan Card",
  "TMB PMJDY Card",
  "TMB Mudra Card",
  "City Union Rupay Classic Debit Card",
  "City Union Rupay PMJDY Debit Card",
  "Nainital RuPay Debit Card (standard)",
  "Nainital Contactless Debit Card",
  "ICICI Rubyx Debit Card",
  "ICICI Platinum Chip Debit Card",
  "ICICI Titanium Debit Card",
  "ICICI RuPay Contactless NCMC Debit Card",
  "BOM Rupay Classic Card Debit Card",
  "BOM Rupay Select Card  Debit Card",
  "BOM Rupay Platinum Card Debit Card",
  "BOM Rupay Petro Card Debit Card",
  "BOM Rupay PMJDY Card Debit Card",
  "IOB Rupay Classic",
  "IOB Rupay Platinum",
  "IOB Rupay Select",
  "IOB Rupay Kisan",
  "IOB Rupay PMJDY",
  "IOB Rupay Mudra EMV",
  "PSB Rupay Classic Debit Card",
  "PSB RUpay Platinum Debit Card",
  "PSB Rupay Platinum Women Debit Card",
  "PSB Rupay Select Debit Card",
  "PSB Rupay Classic International Debit Card",
  "DBS RuPay Platinum",
  "DBS RuPay Classic",
];

function ScrollingChipRow({ label, items, type, onChipClick, extraClassName = "" }) {
  const groupRef = useRef(null);
  const [duration, setDuration] = useState(45);

  useLayoutEffect(() => {
    const updateDuration = () => {
      if (!groupRef.current) return;
      const groupWidth = groupRef.current.scrollWidth;
      const pixelsPerSecond = 80;
      setDuration(Math.max(12, groupWidth / pixelsPerSecond));
    };

    updateDuration();
    window.addEventListener("resize", updateDuration);
    return () => window.removeEventListener("resize", updateDuration);
  }, [items]);

  const rowContent = (
    <>
      <strong className="chip-marquee-label">{label}:</strong>
      {items.map((name, idx) => (
        <span
          key={`${type}-chip-${idx}`}
          role="button"
          tabIndex={0}
          onClick={() => onChipClick(name, type)}
          onKeyDown={(e) => (e.key === "Enter" ? onChipClick(name, type) : null)}
          className="chip"
          title={`Click to select this ${type} card`}
        >
          {name}
        </span>
      ))}
    </>
  );

  return (
    <div className={`chip-marquee ${extraClassName}`.trim()}>
      <div
        className="chip-marquee-track"
        style={{ "--chip-marquee-duration": `${duration}s` }}
      >
        <div className="chip-marquee-group" ref={groupRef}>
          {rowContent}
        </div>
        <div className="chip-marquee-group" aria-hidden="true">
          {rowContent}
        </div>
      </div>
    </div>
  );
}

/* ====== Helpers ====== */
const toNorm = (s) =>
  String(s || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/\s+/g, " ")
    .trim();

/* 🔹 Levenshtein distance */
function lev(a, b) {
  a = toNorm(a);
  b = toNorm(b);
  const n = a.length;
  const m = b.length;
  if (!n) return m;
  if (!m) return n;
  const d = Array.from({ length: n + 1 }, () => Array(m + 1).fill(0));
  for (let i = 0; i <= n; i++) d[i][0] = i;
  for (let j = 0; j <= m; j++) d[0][j] = j;
  for (let i = 1; i <= n; i++) {
    for (let j = 1; j <= m; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(
        d[i - 1][j] + 1,
        d[i][j - 1] + 1,
        d[i - 1][j - 1] + cost
      );
    }
  }
  return d[n][m];
}

/* 🔹 Base text similarity score */
function scoreCandidate(q, cand) {
  const qs = toNorm(q);
  const cs = toNorm(cand);
  if (!qs) return 0;
  if (cs.includes(qs)) return 100;

  const qWords = qs.split(" ").filter(Boolean);
  const cWords = cs.split(" ").filter(Boolean);

  const matchingWords = qWords.filter((qw) =>
    cWords.some((cw) => cw.includes(qw))
  ).length;
  const sim = 1 - lev(qs, cs) / Math.max(qs.length, cs.length);

  return (matchingWords / Math.max(1, qWords.length)) * 0.7 + sim * 0.3;
}

/* 🔹 Fuzzy word-level match, so "selct" still hits "select" */
function isFuzzyNameMatch(query, label) {
  const q = toNorm(query);
  const l = toNorm(label);
  if (!q || !l) return false;

  if (l.includes(q)) return true;

  const wholeDist = lev(q, l);
  const wholeSim = 1 - wholeDist / Math.max(q.length, l.length);
  if (wholeSim >= 0.6) return true;

  const qWords = q.split(" ").filter(Boolean);
  const lWords = l.split(" ").filter(Boolean);

  for (const qw of qWords) {
    if (qw.length < 3) continue;
    for (const lw of lWords) {
      if (lw.length < 3) continue;
      const d = lev(qw, lw);
      const sim = 1 - d / Math.max(qw.length, lw.length);
      if (sim >= 0.7) return true;
    }
  }
  return false;
}

const stripParen = (s) => String(s || "").replace(/\s*\([^)]*\)\s*$/, "").trim();

const splitList = (val) =>
  String(val || "")
    .replace(/\n/g, " ")
    .split(/,|\/| and | AND /g)
    .map((x) => x.trim())
    .filter(Boolean);

/* CRA/Webpack-safe public URL builder */
const publicUrl = (path) => {
  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "") + "/";
  const cleanPath = String(path).replace(/^\/+/, "");
  return base + cleanPath;
};

/* URL normalizer */
const normalizeUrl = (u) => {
  if (!u || typeof u !== "string") return "";
  const s = u.trim();
  if (!s) return "";
  if (/^(https?:)?\/\//i.test(s) || s.startsWith("data:")) return s;
  return "https://" + s;
};

/* fallback logo for RuPay/RuPay Debit if JSON image is missing or broken */
const RUPAY_FALLBACK_IMG =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJX-kIkzGyUlRX9t0qUcmX66YBERIAq5-ywg&s";

/* Sets for fast lookup */
const RUPAY_CREDIT_SET = new Set(
  RupayCards.map((c) => toNorm(stripParen(c)))
);
const RUPAY_DEBIT_SET = new Set(
  RupayDebitCards.map((c) => toNorm(stripParen(c)))
);

/* Find JSON header (handles BOM) */
const findHeader = (rows, wanted) => {
  const w = String(wanted).toLowerCase();
  if (!rows || !rows.length) return wanted;
  const keys = Object.keys(rows[0] || {});
  for (const k of keys) {
    const clean = k.replace(/^\uFEFF/, "");
    if (clean.toLowerCase() === w) return k;
  }
  return wanted;
};

export default function App() {
  /* dropdown data */
  const [creditEntries, setCreditEntries] = useState([]);
  const [debitEntries, setDebitEntries] = useState([]);

  /* dropdown UI */
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredList, setFilteredList] = useState([]); // [{type:'heading'|'credit'|'debit', label/display}]
  const [showDropdown, setShowDropdown] = useState(false);
  const inputRef = useRef(null);

  /* selection & offer visibility */
  const [selected, setSelected] = useState(null); // {type:'credit'|'debit', display}
  const [isEligible, setIsEligible] = useState(false);

  /* typing-time messages */
  const [showError, setShowError] = useState(false); // "No offers for this card"
  const [typedNotEligible, setTypedNotEligible] = useState(false); // "No offer available right now."

  /* responsive / scroll button */
  const [isMobile, setIsMobile] = useState(false);

  /* offers (credit + debit) */
  const [rupayOffers, setRupayOffers] = useState([]);
  const [loadingCreditJSON, setLoadingCreditJSON] = useState(true);

  const [rupayDebitOffers, setRupayDebitOffers] = useState([]);
  const [loadingDebitJSON, setLoadingDebitJSON] = useState(true);

  /* ====== Load allCards.json ====== */
  useEffect(() => {
    async function loadAll() {
      try {
        const url = publicUrl("allCards.json");
        const res = await axios.get(url, { responseType: "json" });
        if (!Array.isArray(res.data)) {
          throw new Error("Expected a JSON array");
        }
        const rows = res.data;

        const ccKey = findHeader(rows, "Eligible Credit Cards");
        const dcKey = findHeader(rows, "Eligible Debit Cards");

        const ccMap = new Map();
        const dcMap = new Map();

        for (const row of rows) {
          const ccVal = row[ccKey];
          if (ccVal) {
            for (const name of splitList(ccVal)) {
              const base = stripParen(name);
              const norm = toNorm(base);
              if (norm && !ccMap.has(norm)) ccMap.set(norm, base);
            }
          }
          const dcVal = row[dcKey];
          if (dcVal) {
            for (const name of splitList(dcVal)) {
              const base = stripParen(name);
              const norm = toNorm(base);
              if (norm && !dcMap.has(norm)) dcMap.set(norm, base);
            }
          }
        }

        const ccArr = Array.from(ccMap.values()).sort((a, b) =>
          a.localeCompare(b)
        );
        const dcArr = Array.from(dcMap.values()).sort((a, b) =>
          a.localeCompare(b)
        );

        setCreditEntries(ccArr);
        setDebitEntries(dcArr);

        // default dropdown (no search): Credit then Debit
        setFilteredList([
          ...(ccArr.length ? [{ type: "heading", label: "Credit Cards" }] : []),
          ...ccArr.map((d) => ({ type: "credit", display: d })),
          ...(dcArr.length ? [{ type: "heading", label: "Debit Cards" }] : []),
          ...dcArr.map((d) => ({ type: "debit", display: d })),
        ]);
      } catch (e) {
        console.error(
          "Failed to load",
          publicUrl("allCards.json"),
          e?.message || e
        );
        setCreditEntries([]);
        setDebitEntries([]);
        setFilteredList([]);
      }
    }
    loadAll();
  }, []);

  /* ====== Preload RuPay credit offers ====== */
  useEffect(() => {
    async function loadRupayOffers() {
      try {
        const url = publicUrl("rupay.json");
        const res = await axios.get(url, { responseType: "json" });
        if (!Array.isArray(res.data)) {
          throw new Error("Expected a JSON array");
        }

        const cleaned = (res.data).map((r) => ({
          Image: r.Image || r["Image URL"] || r.image || "",
          Offer: r.Offer || r.Title || r["Offer Title"] || "",
          Link: r.Link || r["Offer Link"] || "",
          Discount: r.Discount ?? "",
          SpendAmount: r["Spend Amount"] ?? "",
          // 🔹 NEW: capture description if present
          Description:
            r.Description ||
            r["Offer Description"] ||
            r["Description"] ||
            "",
        }));

        // keep rows that have at least something
        setRupayOffers(cleaned.filter((r) => r.Image || r.Offer || r.Link));
      } catch (e) {
        console.error(
          "Failed to load",
          publicUrl("rupay.json"),
          e?.message || e
        );
        setRupayOffers([]);
      } finally {
        setLoadingCreditJSON(false);
      }
    }
    loadRupayOffers();
  }, []);

  /* ====== Preload RuPay debit offers ====== */
  useEffect(() => {
    async function loadRupayDebitOffers() {
      try {
        const url = publicUrl("rupay_debit.json");
        const res = await axios.get(url, { responseType: "json" });
        if (!Array.isArray(res.data)) {
          throw new Error("Expected a JSON array");
        }

        const cleaned = (res.data).map((r) => ({
          Image: r.Image || r["Image URL"] || r.image || "",
          Offer: r.Offer || r.Title || r["Offer Title"] || "",
          Link: r.Link || r["Offer Link"] || "",
          Discount: r.Discount ?? "",
          SpendAmount: r["Spend Amount"] ?? "",
          // 🔹 NEW: capture description if present
          Description:
            r.Description ||
            r["Offer Description"] ||
            r["Description"] ||
            "",
        }));

        setRupayDebitOffers(
          cleaned.filter((r) => r.Image || r.Offer || r.Link)
        );
      } catch (e) {
        console.error(
          "Failed to load",
          publicUrl("rupay_debit.json"),
          e?.message || e
        );
        setRupayDebitOffers([]);
      } finally {
        setLoadingDebitJSON(false);
      }
    }
    loadRupayDebitOffers();
  }, []);

  /* ====== Maintain filtered dropdown list based on searchTerm
           (UPDATED: select-intent, debit-intent, fuzzy match) ====== */
  useEffect(() => {
    const raw = searchTerm;
    const trimmed = raw.trim();

    // If nothing typed: show full list (Credit then Debit) like before
    if (!trimmed) {
      const ccArr = creditEntries;
      const dcArr = debitEntries;
      setFilteredList([
        ...(ccArr.length ? [{ type: "heading", label: "Credit Cards" }] : []),
        ...ccArr.map((d) => ({ type: "credit", display: d })),
        ...(dcArr.length ? [{ type: "heading", label: "Debit Cards" }] : []),
        ...dcArr.map((d) => ({ type: "debit", display: d })),
      ]);
      return;
    }

    const qLower = raw.toLowerCase();
    const qNorm = toNorm(raw);

    // 🔹 Debit intent: if user types "dc", "debit", "debit card"
    const debitHint =
      qLower.includes("debit cards") ||
      qLower.includes("debit card") ||
      qLower.includes("debit") ||
      qLower.includes("dc");

    // 🔹 "select" intent (also handles typos like "selct")
    const qWords = qNorm.split(" ").filter(Boolean);
    const hasSelectWord = qWords.some((w) => {
      if (w === "select") return true;
      if (w.length < 3) return false;
      const d = lev(w, "select");
      const sim = 1 - d / Math.max(w.length, "select".length);
      return sim >= 0.7; // 'selct', 'selec', etc.
    });

    const isSelectIntent =
      qNorm.includes("select credit card") ||
      qNorm.includes("select card") ||
      hasSelectWord;

    const buildMatches = (entries, type) => {
      return entries
        .map((name) => {
          const baseScore = scoreCandidate(raw, name);
          const inc = name.toLowerCase().includes(qLower);
          const fuzzy = isFuzzyNameMatch(raw, name);

          let score = baseScore;
          if (inc) score += 2.0; // strong substring boost
          if (fuzzy) score += 1.5; // fuzzy boost

          return {
            type,
            display: name,
            score,
            inc,
            fuzzy,
          };
        })
        .filter((row) => {
          if (!qNorm) return true;
          return row.inc || row.fuzzy || row.score > 0.3;
        })
        .sort((a, b) => {
          if (b.score !== a.score) return b.score - a.score;
          return a.display.localeCompare(b.display);
        });
    };

    let creditMatches = buildMatches(creditEntries, "credit");
    let debitMatches = buildMatches(debitEntries, "debit");

    // 🔹 If intent is "select", move cards containing "select" to top
    if (isSelectIntent) {
      const reorderBySelect = (arr) => {
        const selectOnes = [];
        const others = [];
        arr.forEach((item) => {
          const labelNorm = toNorm(item.display);
          if (labelNorm.includes("select")) selectOnes.push(item);
          else others.push(item);
        });
        return [...selectOnes, ...others];
      };
      creditMatches = reorderBySelect(creditMatches);
      debitMatches = reorderBySelect(debitMatches);
    }

    const combined = [];

    if (debitHint) {
      // 🔹 Debit section FIRST if query hints "debit"
      if (debitMatches.length > 0) {
        combined.push({ type: "heading", label: "Debit Cards" });
        combined.push(...debitMatches);
      }
      if (creditMatches.length > 0) {
        combined.push({ type: "heading", label: "Credit Cards" });
        combined.push(...creditMatches);
      }
    } else {
      // default: Credit then Debit
      if (creditMatches.length > 0) {
        combined.push({ type: "heading", label: "Credit Cards" });
        combined.push(...creditMatches);
      }
      if (debitMatches.length > 0) {
        combined.push({ type: "heading", label: "Debit Cards" });
        combined.push(...debitMatches);
      }
    }

    setFilteredList(combined);
  }, [searchTerm, creditEntries, debitEntries]);

  /* ====== Typing-time messages ====== */
  useEffect(() => {
    if (selected) return;

    const q = searchTerm.trim();
    if (!q) {
      setShowError(false);
      setTypedNotEligible(false);
      return;
    }

    const hasAnyOptions = filteredList.some((it) => it.type !== "heading");
    if (!hasAnyOptions) {
      // typed card not in our known CC/DC lists at all
      setShowError(true);
      setTypedNotEligible(false);
      return;
    }

    const norm = toNorm(stripParen(q));
    const inCC = creditEntries.some(
      (c) => toNorm(stripParen(c)) === norm
    );
    const inDC = debitEntries.some(
      (c) => toNorm(stripParen(c)) === norm
    );

    if (
      (inCC && !RUPAY_CREDIT_SET.has(norm)) ||
      (inDC && !RUPAY_DEBIT_SET.has(norm))
    ) {
      // we know this card but it's not RuPay-eligible
      setShowError(false);
      setTypedNotEligible(true);
    } else {
      setShowError(false);
      setTypedNotEligible(false);
    }
  }, [selected, searchTerm, filteredList, creditEntries, debitEntries]);

  /* ====== Handlers ====== */
  const selectEntry = (entry) => {
    const display = stripParen(entry.display);
    const norm = toNorm(display);

    if (entry.type === "credit") {
      const eligible = RUPAY_CREDIT_SET.has(norm);
      setSelected({ type: "credit", display });
      setIsEligible(eligible);
      setShowError(!eligible); // show "No offers for this card" if not eligible
      setTypedNotEligible(false);
    } else {
      const eligible = RUPAY_DEBIT_SET.has(norm);
      setSelected({ type: "debit", display });
      setIsEligible(eligible);
      setShowError(!eligible);
      setTypedNotEligible(false);
    }

    setSearchTerm(display);
    setShowDropdown(false);
  };

  const handleInputChange = (e) => {
    const v = e.target.value;

    // user starts typing again -> clear previous selection/offers
    if (selected) {
      setSelected(null);
      setIsEligible(false);
    }

    setSearchTerm(v);
    if (!showDropdown) setShowDropdown(true);

    // if cleared, also clear errors
    if (!v.trim()) {
      setShowError(false);
      setTypedNotEligible(false);
    }
  };

  const handleChipClick = (name, type) => {
    selectEntry({ type, display: name });
  };

  /* dropdown focus mgmt */
  const blurTimeout = useRef(null);
  const onFocus = () => {
    if (blurTimeout.current) clearTimeout(blurTimeout.current);
    setShowDropdown(true);
  };
  const onBlur = () => {
    blurTimeout.current = setTimeout(() => setShowDropdown(false), 120);
  };

  /* responsive scroll button rule */
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* ====== what's currently shown ====== */
  const currentOffers =
    selected?.type === "debit" ? rupayDebitOffers : rupayOffers;
  const sortedCurrentOffers = [...currentOffers].sort(
    (a, b) => Number(b.Discount || 0) - Number(a.Discount || 0)
  );
  const currentLoading =
    selected?.type === "debit" ? loadingDebitJSON : loadingCreditJSON;

  const shouldShowOffers = Boolean(selected && isEligible);

  const hasAnyOffers =
    shouldShowOffers && !currentLoading && currentOffers.length > 0;

  const noOffersInJSON =
    shouldShowOffers && !currentLoading && currentOffers.length === 0;

  const Disclaimer = () => (
    <section className="disclaimer">
      <h3>Disclaimer</h3>
      <p>
        All offers, coupons, and discounts listed on our platform are
        provided for informational purposes only. We do not guarantee
        the accuracy, availability, or validity of any offer. Users are
        advised to verify the terms and conditions with the respective
        merchants before making any purchase. We are not responsible
        for any discrepancies, expired offers, or losses arising from
        the use of these coupons.
      </p>
    </section>
  );

  return (
    <div className="App" style={{ fontFamily: "'Libre Baskerville', serif" }}>
      {/* ========== Chips marquee strip ========== */}
      <div
        style={{
          maxWidth: 1200,
          margin: "14px auto 8px",
          padding: "14px 16px",
          background: "#F7F9FC",
          border: "1px solid #E8EDF3",
          borderRadius: 10,
          boxShadow: "0 6px 18px rgba(15,23,42,.06)",
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: 16,
            color: "#1F2D45",
            marginBottom: 10,
            textAlign: "center",
          }}
        >
          Cards Which Have Offers
        </div>

        {/* Credit cards strip */}
        {RupayCards.length > 0 && (
          <ScrollingChipRow
            label="Credit Cards"
            items={RupayCards}
            type="credit"
            onChipClick={handleChipClick}
            extraClassName="chip-marquee-spaced"
          />
        )}

        {/* Debit cards strip */}
        {RupayDebitCards.length > 0 && (
          <ScrollingChipRow
            label="Debit Cards"
            items={RupayDebitCards}
            type="debit"
            onChipClick={handleChipClick}
          />
        )}
      </div>

      {/* ========== Search / Dropdown ========== */}
      <div
        className="dropdown"
        style={{
          position: "relative",
          width: 600,
          maxWidth: "92vw",
          margin: "20px auto",
        }}
      >
        <input
          ref={inputRef}
          type="text"
          placeholder="Enter card name to check the offers..."
          value={searchTerm}
          className="dropdown-input"
          onChange={handleInputChange}
          onFocus={onFocus}
          onBlur={onBlur}
          style={{
            width: "100%",
            padding: "12px",
            fontSize: 16,
            border: `1px solid ${showError ? "#d32f2f" : "#ccc"}`,
            borderRadius: 6,
          }}
        />

        {showDropdown && filteredList.length > 0 && (
          <ul
            className="dropdown-list"
            style={{
              listStyle: "none",
              padding: 10,
              margin: 0,
              width: "100%",
              maxHeight: 320,
              overflowY: "auto",
              border: "1px solid #ccc",
              borderRadius: 6,
              backgroundColor: "#fff",
              position: "absolute",
              zIndex: 1000,
            }}
            onMouseDown={(e) => e.preventDefault()} // keep focus so click works
          >
            {filteredList.map((item, idx) =>
              item.type === "heading" ? (
                <li
                  key={`h-${idx}`}
                  style={{
                    padding: "8px 10px",
                    fontWeight: 700,
                    background: "#fafafa",
                  }}
                >
                  {item.label}
                </li>
              ) : (
                <li
                  key={`i-${idx}-${item.display}`}
                  onClick={() => selectEntry(item)}
                  style={{
                    padding: 10,
                    cursor: "pointer",
                    borderBottom: "1px solid #f2f2f2",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "#f7f9ff")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "transparent")
                  }
                >
                  {item.display}
                </li>
              )
            )}
          </ul>
        )}
      </div>

      {/* Typing-time messages */}
      {showError && (
        <p style={{ color: "#d32f2f", textAlign: "center", marginTop: 8 }}>
          No offers for this card
        </p>
      )}
      {!selected && !showError && typedNotEligible && (
        <p style={{ color: "#d32f2f", textAlign: "center", marginTop: 8 }}>
          No offer available right now.
        </p>
      )}

      {/* ========== Offer Grid Section ========== */}
      {shouldShowOffers && (
        <div
          className="offers-section"
          style={{ maxWidth: 1200, margin: "0 auto", padding: 20 }}
        >
          <h2 style={{ textAlign: "center", marginBottom: 22 }}>
            Offers For RuPay {selected?.type === "debit" ? "Debit" : "Credit"} Card
          </h2>

          {currentLoading && (
            <p style={{ textAlign: "center", opacity: 0.7 }}>Loading offers…</p>
          )}

          {!currentLoading && currentOffers.length > 0 && (
            <div className="offer-grid">
              {sortedCurrentOffers.map((o, i) => {
                // pick the JSON image if present, else fallback
                const rawImg = o.Image || "";
                const finalImage = normalizeUrl(rawImg) || RUPAY_FALLBACK_IMG;

                const offerText = String(o.Offer || "").trim();
                const description = String(o.Description || "").trim(); // 🔹 NEW
                const spendAmount = String(o.SpendAmount || "0").trim();
                const link = normalizeUrl(o.Link || "");

                // Don't render a totally empty tile
                if (!finalImage && !offerText && !link && !description) return null;

                return (
                  <div key={i} className="offer-card">
                    {finalImage && (
                      <img
                        src={finalImage}
                        alt={`Offer ${i + 1}`}
                        loading="lazy"
                        onError={(e) => {
                          // if provided URL fails, fallback to RuPay logo
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = RUPAY_FALLBACK_IMG;
                        }}
                      />
                    )}

                    <div className="offer-info">
                      {offerText && (
                        <div className="offer-desc">{offerText}</div>
                      )}

                      <div className="offer-desc">
                        Minimum Spend Amount: {spendAmount || "0"}
                      </div>

                      {/* 🔹 NEW: Description shown above View Offer button */}
                      {description && (
                        <div
                          className="offer-desc offer-details"
                          tabIndex={0}
                          role="region"
                          aria-label={`Description and terms for ${offerText || "offer"}`}
                          style={{ marginTop: 4 }}
                        >
                          {description}
                        </div>
                      )}

                      {link && (
                        <button
                          className="btn"
                          onClick={() =>
                            window.open(link, "_blank", "noopener,noreferrer")
                          }
                        >
                          View Offer
                        </button>
                      )}

                      {offerText && (
                        <div className="offer-desc" style={{ marginTop: 12, color: "red" }}>
                          Offer on {offerText}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {noOffersInJSON && (
            <p
              style={{
                color: "#d32f2f",
                textAlign: "center",
                marginTop: 10,
              }}
            >
              No offer available right now.
            </p>
          )}
        </div>
      )}

      <Disclaimer />

      {/* Sticky scroll button */}
      {hasAnyOffers && (
        <button
          onClick={() =>
            window.scrollBy({ top: window.innerHeight, behavior: "smooth" })
          }
          style={{
            position: "fixed",
            right: 20,
            bottom: isMobile ? 220 : 250,
            padding: isMobile ? "12px 15px" : "10px 20px",
            backgroundColor: "#1e7145",
            color: "white",
            border: "none",
            borderRadius: isMobile ? "50%" : 8,
            cursor: "pointer",
            fontSize: 18,
            zIndex: 1000,
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            width: isMobile ? 50 : 140,
            height: isMobile ? 50 : 50,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {isMobile ? "↓" : "Scroll Down"}
        </button>
      )}
    </div>
  );
}
